// extracted by mini-css-extract-plugin
export default {"jdc-container":"Banner_jdc-container__x8t3y","banner":"Banner_banner__C9vZp","title":"Banner_title__C+aJj","subtitle":"Banner_subtitle__WbB-+","img-nav":"Banner_img-nav__9wN4Z"};